"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _get = _interopRequireDefault(require("lodash/get"));

var _range = _interopRequireDefault(require("lodash/range"));

var _min = _interopRequireDefault(require("lodash/min"));

var _max = _interopRequireDefault(require("lodash/max"));

var _reactVis = require("react-vis");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _ResizableXYPlot = _interopRequireDefault(require("./ResizableXYPlot"));

var _colors = require("../constants/colors");

var _chartUtils = require("../chartUtils");

var _HintDateRange = _interopRequireDefault(require("./HintDateRange"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDateTimesBetween = function getDateTimesBetween(dateRange, settings, timeMeasurementUnit) {
  var startDateTime = dateRange.startDateTime,
      endDateTime = dateRange.endDateTime;

  var count = _luxon.Interval.fromDateTimes(startDateTime, endDateTime).count(timeMeasurementUnit);

  var dateTimes = (0, _range["default"])(count).map(function (x, index) {
    return startDateTime.plus(_defineProperty({}, timeMeasurementUnit, index)).set(settings);
  });
  return dateTimes;
};

var isReportingZero = function isReportingZero(reading) {
  return reading && reading.deliveredKwh === '0';
};

var isMissingData = function isMissingData(reading) {
  return !reading;
};

var isBadData = function isBadData(reading) {
  return reading && !(0, _chartUtils.isNumeric)(reading.deliveredKwh);
};

var isMissingDaytimeReadings = function isMissingDaytimeReadings(reading) {
  return Number((0, _get["default"])(reading, 'readingCounts.DELIVERED.totalMissingDaytime', '0')) > 0;
};

var isMissingReadings = function isMissingReadings(reading) {
  return Number((0, _get["default"])(reading, 'readingCounts.DELIVERED.totalMissing', '0')) > 0;
};

var ERROR = 'Error';
var MISSING_DATA = 'Missing Data';
var PARTIAL_DATA = 'Partial Data';
var GOOD = 'Measured';

var computeReadingState = function computeReadingState(reading) {
  if (isMissingData(reading)) {
    return MISSING_DATA;
  }

  if (isReportingZero(reading) || isBadData(reading)) {
    return ERROR;
  }

  if (isMissingReadings(reading) || isMissingDaytimeReadings(reading)) {
    return PARTIAL_DATA;
  }

  return GOOD;
};

var HintBody = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);\n  color: ", ";\n  padding: 15px 20px;\n"])), _colors.WHITE, _colors.NAVY);

var MeasurementName = _styled["default"].strong(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 10px;\n"])));

var Wrapper = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 12;\n"])));

var Label = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  border: 2px solid ", ";\n  bottom: 0;\n  display: flex;\n  font-size: 8px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 40px;\n"])), _colors.GREEN);

var reduceGroupedCoords = function reduceGroupedCoords(groupedCoords, measurement) {
  return groupedCoords.reduce(function (result, coords) {
    var x0 = (0, _min["default"])(coords.map(function (c) {
      return c.x0;
    }));
    var x = (0, _max["default"])(coords.map(function (c) {
      return c.x;
    }));
    result.push({
      x0: x0,
      x: x,
      y0: 0,
      y: 15,
      measurement: measurement
    });
    return result;
  }, []);
};

var MeterBarChart = /*#__PURE__*/function (_PureComponent) {
  _inherits(MeterBarChart, _PureComponent);

  var _super = _createSuper(MeterBarChart);

  function MeterBarChart() {
    var _this;

    _classCallCheck(this, MeterBarChart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.wrapperEl = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      cursorX: 0,
      selectedCoordinate: null
    };
    _this.transformToCoordinates = (0, _memoizeOne["default"])(function (siteProductionDailyReadings, minDateISO, maxDateISO, zone) {
      var readingsDictionary = siteProductionDailyReadings.reduce(function (d, r) {
        var key = _luxon.DateTime.fromISO(r.readingEndTimeLocal, {
          zone: zone
        }).toISODate();

        d[key] = r;
        return d;
      }, {});

      var datesBetween = _this.getDates(minDateISO, maxDateISO, zone);

      var millisecondsPerDay = _this.getMillisecondsPerDay(minDateISO, maxDateISO, zone);

      var coordinates = datesBetween.map(function (dt) {
        var isoDate = dt.toISODate();
        var millis = dt.toMillis();
        var x0 = millis;
        var x = millis + millisecondsPerDay;
        var measurement = computeReadingState(readingsDictionary[isoDate]);
        return {
          x0: x0,
          x: x,
          y0: 0,
          y: 15,
          measurement: measurement
        };
      }).filter(function (c) {
        return c.measurement !== GOOD;
      }); // Group neighboring partial data coodinates

      var groupedPartialDataCoordinates = (0, _chartUtils.splitCoordinatesOnUnexpectedDelta)(coordinates.filter(function (c) {
        return c.measurement === PARTIAL_DATA;
      }), _luxon.Duration.fromObject({
        days: 1
      })); // Reduce neighboring coordinates to a single coordinate, so we can show crosshatch style uniterrupted and for hover

      var partialDataCoords = reduceGroupedCoords(groupedPartialDataCoordinates, PARTIAL_DATA); // Group neighboring missing data coordinates

      var groupedMissingDataCoordinates = (0, _chartUtils.splitCoordinatesOnUnexpectedDelta)(coordinates.filter(function (c) {
        return c.measurement === MISSING_DATA;
      }), _luxon.Duration.fromObject({
        days: 1
      })); // Show missing data as a single coordinate for styling purposes and hover

      var missingDataCoords = groupedMissingDataCoordinates.reduce(function (result, coords) {
        var x0 = (0, _min["default"])(coords.map(function (c) {
          return c.x0;
        }));
        var x = (0, _max["default"])(coords.map(function (c) {
          return c.x;
        }));
        result.push({
          x0: x0,
          x: x,
          y0: 0,
          y: 15,
          measurement: MISSING_DATA
        });
        return result;
      }, []);
      var groupedErrorCoordinates = (0, _chartUtils.splitCoordinatesOnUnexpectedDelta)(coordinates.filter(function (c) {
        return c.measurement === ERROR;
      }), _luxon.Duration.fromObject({
        days: 1
      }));
      var errorCoordinates = reduceGroupedCoords(groupedErrorCoordinates, ERROR);
      return {
        errorCoordinates: errorCoordinates,
        missingDataCoords: missingDataCoords,
        partialDataCoords: partialDataCoords
      };
    });

    _this.getDates = function (startDateISO, endDateISO, zone) {
      var startDateTime = _luxon.DateTime.fromISO(startDateISO, {
        zone: zone
      });

      var endDateTime = _luxon.DateTime.fromISO(endDateISO, {
        zone: zone
      });

      var datesBetween = getDateTimesBetween({
        startDateTime: startDateTime,
        endDateTime: endDateTime
      }, {
        hour: 0
      }, 'days');
      return datesBetween;
    };

    _this.getMillisecondsPerDay = function (startDateISO, endDateISO, zone) {
      var startDateTime = _luxon.DateTime.fromISO(startDateISO, {
        zone: zone
      });

      var endDateTime = _luxon.DateTime.fromISO(endDateISO, {
        zone: zone
      });

      var interval = _luxon.Interval.fromDateTimes(startDateTime, endDateTime);

      return interval.count('milliseconds') / interval.length('days');
    };

    return _this;
  }

  _createClass(MeterBarChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          maxDateISO = _this$props.maxDateISO,
          minDateISO = _this$props.minDateISO,
          siteProductionDailyReadings = _this$props.siteProductionDailyReadings,
          viewEndISO = _this$props.viewEndISO,
          viewStartISO = _this$props.viewStartISO,
          zone = _this$props.zone;
      var _this$state = this.state,
          cursorX = _this$state.cursorX,
          selectedCoordinate = _this$state.selectedCoordinate; // Map readings to dictionary with ISO Date key yyyy-mm-dd

      var _this$transformToCoor = this.transformToCoordinates(siteProductionDailyReadings, minDateISO, maxDateISO, zone),
          errorCoordinates = _this$transformToCoor.errorCoordinates,
          missingDataCoords = _this$transformToCoor.missingDataCoords,
          partialDataCoords = _this$transformToCoor.partialDataCoords;

      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        ref: this.wrapperEl
      }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
        height: 15,
        xType: "time",
        margin: {
          top: 0,
          left: 70,
          right: 0,
          bottom: 0
        },
        onMouseMove: function onMouseMove(e) {
          var rect = _this2.wrapperEl.current.getBoundingClientRect();

          _this2.setState({
            cursorX: e.clientX - rect.x
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            selectedCoordinate: null
          });
        },
        xDomain: [_luxon.DateTime.fromISO(viewStartISO, {
          zone: zone
        }).toMillis(), _luxon.DateTime.fromISO(viewEndISO, {
          zone: zone
        }).toMillis()],
        style: {
          background: _colors.GREEN
        },
        yDomain: [0, 15]
      }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("pattern", {
        id: "partial-data-crosshatch",
        width: "4",
        height: "4",
        patternUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        className: "vx-pattern-line",
        d: "M 0,4 l 4,-4 M -1,1 l 2,-2 M 3,5 l 2,-2",
        stroke: _colors.GREEN,
        strokeWidth: "1",
        strokeLinecap: "square",
        shapeRendering: "auto"
      }))), /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
        colorType: "literal",
        color: _colors.RED,
        data: errorCoordinates,
        onValueMouseOver: function onValueMouseOver(c) {
          return _this2.setState({
            selectedCoordinate: c
          });
        },
        onValueMouseOut: function onValueMouseOut() {
          return _this2.setState({
            selectedCoordinate: null
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
        data: missingDataCoords.concat(partialDataCoords),
        colorType: "literal",
        fill: _colors.WHITE,
        onValueMouseOver: function onValueMouseOver(c) {
          return _this2.setState({
            selectedCoordinate: c
          });
        },
        onValueMouseOut: function onValueMouseOut() {
          return _this2.setState({
            selectedCoordinate: null
          });
        },
        stroke: _colors.GREEN,
        style: {
          strokeWidth: 3
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
        data: partialDataCoords,
        colorType: "literal",
        fill: "url(#partial-data-crosshatch)",
        onValueMouseOver: function onValueMouseOver(c) {
          return _this2.setState({
            selectedCoordinate: c
          });
        },
        onValueMouseOut: function onValueMouseOut() {
          return _this2.setState({
            selectedCoordinate: null
          });
        },
        stroke: _colors.GREEN,
        style: {
          strokeWidth: 3
        }
      }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(_reactVis.Hint, {
        getAlignStyle: function getAlignStyle() {
          return {
            left: cursorX
          };
        },
        value: selectedCoordinate
      }, /*#__PURE__*/_react["default"].createElement(HintBody, null, /*#__PURE__*/_react["default"].createElement(MeasurementName, null, selectedCoordinate.measurement), /*#__PURE__*/_react["default"].createElement(_HintDateRange["default"], {
        coordinate: selectedCoordinate,
        zone: zone
      }))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
        style: {
          left: {
            fill: '#fff'
          }
        }
      })), /*#__PURE__*/_react["default"].createElement(Label, null, "DATA"));
    }
  }]);

  return MeterBarChart;
}(_react.PureComponent);

MeterBarChart.propTypes = {
  maxDateISO: _propTypes["default"].string.isRequired,
  siteProductionDailyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    deliveredKwh: _propTypes["default"].string,
    readingEndTimeLocal: _propTypes["default"].string,
    readingCounts: _propTypes["default"].shape({
      DELIVERED: _propTypes["default"].shape({
        totalMissing: _propTypes["default"].string,
        totalDaytime: _propTypes["default"].string,
        totalMissingDaytime: _propTypes["default"].string,
        total: _propTypes["default"].string
      })
    })
  })),
  minDateISO: _propTypes["default"].string.isRequired,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string
};
MeterBarChart.defaultProps = {
  siteProductionDailyReadings: [],
  zone: 'local'
};
var _default = MeterBarChart;
exports["default"] = _default;